import React from 'react';
import { InsuranceItem } from '../../types/hospital.types';

interface EditableFieldProps {
  label: string;
  value: string | number;
  editValue?: string | boolean | InsuranceItem[];
  isEditing: boolean;
  type?: 'text' | 'textarea' | 'select' | 'insurance';
  options?: { value: string; label: string }[];
  placeholder?: string;
  onChange: (value: string | boolean | InsuranceItem[]) => void;
}

const EditableField: React.FC<EditableFieldProps> = ({
  label,
  value,
  editValue,
  isEditing,
  type = 'text',
  options,
  placeholder,
  onChange
}) => {
  const renderEditInput = () => {
    // if (type === 'insurance') {
    //   const stringValue = Array.isArray(editValue) 
    //     ? editValue.map(item => item.nameOfInsurer).join(', ')
    //     : '';
      
    //   return (
    //     <textarea
    //       value={stringValue}
    //       onChange={(e) => onChange(editValue || [])}
    //       className="edit-input"
    //       onClick={(e) => e.stopPropagation()}
    //       rows={2}
    //       placeholder={placeholder}
    //     />
    //   );
    // }

    if (type === 'textarea') {
      return (
        <textarea
          value={editValue as string || ''}
          onChange={(e) => onChange(e.target.value)}
          className="edit-input"
          onClick={(e) => e.stopPropagation()}
          rows={2}
          placeholder={placeholder}
        />
      );
    }
    
    if (type === 'select' && options) {
      return (
        <select
          value={editValue?.toString() || 'false'}
          onChange={(e) => onChange(e.target.value === 'true')}
          className="edit-input"
          onClick={(e) => e.stopPropagation()}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }
    
    return (
      <input
        type="text"
        value={editValue as string || ''}
        onChange={(e) => onChange(e.target.value)}
        className="edit-input"
        onClick={(e) => e.stopPropagation()}
        placeholder={placeholder}
      />
    );
  };

  return (
    <div className="field-row">
      <label>{label}:</label>
      {isEditing ? renderEditInput() : <span>{value}</span>}
    </div>
  );
};

export default EditableField;